﻿
import angular from 'angular';

import './cart-product';
import '../../../services/cart';
import '../../../services/datastorage';

angular.module('folkeuni').component('cart', {
  bindings: {
    cart: '=',
    state: '<'
  },
  controller: function(Cart, DataStorage, $location, $window) {
    var $ctrl = this;
    
    $ctrl.back = function() {
      DataStorage.get("lastUsedDepartmentProgram").then(function(data){
        let goto = data;
        if (document.referrer) {
          // Determin if referrer is valid back navigation. Handles if referrer is external (then use referrer), or if its the checkout page (then don't use referrer)
          const validReferrer = !(document.referrer.includes(window.location.hostname) || document.referrer.includes('checkout'));

          if (validReferrer) {
            goto = document.referrer.substring(0, document.referrer.indexOf('/program') + 9);
            DataStorage.set('lastUsedDepartmentProgram', goto);
          }
        }
        $window.location = goto;
      },function(message){
        $window.location = '/';
      });
    };

    $ctrl.next = function() {
      var hasStudendDiscount = Cart.hasStudentTickets($ctrl.cart);
      var hasOrganizationTickets = Cart.hasOrganizationTickets($ctrl.cart);

      if (hasStudendDiscount) {
        $location.path('discounts');
      }
      else if(hasOrganizationTickets){
        $location.path('organization');        
      } else {
        $location.path('delivery');
      }
    };
  },


  templateUrl: '/shop-dist/templates/cart.html?c=' + window.cacheBurst,
  transclude: true
});
